import tableAppTagsBlackLabel from './tableAppTagsBlackLabel';

export default {
  title: 'Tag Customization',
  attributeName: 'tags',
  getURL: 'appId/tags',
  createURL: 'appId/tags',
  updateURL: 'appId/tags',
  removeURL: 'appId/tags',
  sessionParams: ['appId'],
  itemId: 'id',
  itemName: 'name',
  tableConfig: tableAppTagsBlackLabel,
  // autoUpdate: true,
  noArea:true,

};
